import "core-js/modules/es7.array.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';

var TitleSection = function TitleSection() {
  return import(
  /* webpackChunkName: "title-section", webpackMode: "eager" */
  '~/components/atoms/Editorial/TitleSection.vue');
};

var SubtitleSection = function SubtitleSection() {
  return import(
  /* webpackChunkName: "subtitle-section", webpackMode: "eager" */
  '~/components/atoms/Editorial/SubtitleSection.vue');
};

var SimpleParagraph = function SimpleParagraph() {
  return import(
  /* webpackChunkName: "simple-paragraph", webpackMode: "eager" */
  '~/components/atoms/Editorial/SimpleParagraph.vue');
};

var MainImage = function MainImage() {
  return import(
  /* webpackChunkName: "main-image", webpackMode: "eager" */
  '~/components/atoms/Editorial/MainImage.vue');
};

var MdmLink = function MdmLink() {
  return import(
  /* webpackChunkName: "mdm-link", webpackMode: "eager" */
  '~/components/atoms/MdmLink.vue');
};

var COLORS = {
  grey: 'btn-dark',
  transparent: 'btn-transparent'
};
export default {
  name: 'GlobalDispatchFooter',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph,
    MainImage: MainImage,
    MdmLink: MdmLink
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    background: function background() {
      return {
        color: this.payload.primary.background_color || '',
        image: formatPrismicImage(this.payload.primary.image.url) || ''
      };
    },
    title: function title() {
      var type = this.payload.primary.title && this.payload.primary.title[0] && this.payload.primary.title[0].type;
      return {
        text: Object.keys(this.payload.primary.title).length === 0 ? '' : this.payload.primary.title[0],
        color: this.payload.primary.title_color || '',
        type: type || 'heading2'
      };
    },
    subtitle: function subtitle() {
      var type = this.payload.primary.subtitle && this.payload.primary.subtitle[0] && this.payload.primary.subtitle[0].type;
      return {
        text: Object.keys(this.payload.primary.subtitle).length === 0 ? '' : this.payload.primary.subtitle[0],
        color: this.payload.primary.subtitle_color || '',
        type: type || 'heading2'
      };
    },
    simpleParagraph: function simpleParagraph() {
      return this.payload.primary.simple_paragraph || [];
    },
    elements: function elements() {
      return this.payload.items.map(function (item) {
        var small = formatPrismicImage(item.image.url, ['w_375']) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_1440']) || EMPTY_PIXEL;
        var xlarge = formatPrismicImage(item.image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL;
        return {
          src: large,
          srcset: "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1440w, ").concat(xlarge, " 2880w"),
          alt: item.alt || '',
          ratioImages: item.ratio_images || '1:1',
          title: Object.keys(item.title).length === 0 ? '' : item.title[0],
          titleColor: item.title_color,
          simpleParagraphItem: item.simple_paragraph_item || [],
          backgroundColor: item.background_color || '',
          button: {
            url: item.button_url.url || '',
            text: item.button_text || '',
            color: COLORS[item.button_color]
          },
          tracking: {
            data: {
              event_category: item.event_category || '',
              event_action: item.event_action || '',
              event_label: item.event_label || ''
            }
          }
        };
      });
    },
    isHeadingTitle: function isHeadingTitle() {
      var headingTitles = ['heading1', 'heading2', 'heading3', 'heading4', 'heading5', 'heading6'];
      var type = this.payload.primary && this.payload.primary.simple_paragraph && this.payload.primary.simple_paragraph[0] && this.payload.primary.simple_paragraph[0].type;
      return headingTitles.includes(type);
    },
    buttonFirst: function buttonFirst() {
      return {
        url: this.payload.primary.button_url1.url || '',
        text: this.payload.primary.button_text1 || '',
        color: COLORS[this.payload.primary.button_color1],
        tracking: {
          data: {
            event_category: this.payload.primary.event_category1 || '',
            event_action: this.payload.primary.event_action1 || '',
            event_label: this.payload.primary.event_label1 || ''
          }
        }
      };
    },
    buttonSecond: function buttonSecond() {
      return {
        url: this.payload.primary.button_url2.url || '',
        text: this.payload.primary.button_text2 || '',
        color: COLORS[this.payload.primary.button_color2],
        tracking: {
          data: {
            event_category: this.payload.primary.event_category2 || '',
            event_action: this.payload.primary.event_action2 || '',
            event_label: this.payload.primary.event_label2 || ''
          }
        }
      };
    }
  })
};